import Vue from 'vue'
import Vuex from 'vuex'

import MEMBERS from './moudles/member'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    getAppHeaderInfo:{},   //获取app头部信息
  },
  getters:{
    getAppHeaderInfo: (state) => state.getAppHeaderInfo,
  },
  mutations: {
    // 保存app头部信息
    SET_APPHEADERINFO: (state, data) => {
      state.getAppHeaderInfo = data
    },
  },
  actions: {
    setAppHeaderInfos: ({ commit }, data) => {
      commit('SET_APPHEADERINFO', data)
    },
  },
  modules: {
    MEMBERS
  }
})
